import { GenericService } from 'services/index';
import { Observable } from 'rxjs';
import api from 'utils/api';

export class ECommerceService extends GenericService {
	public static getContentById(productID: string): Observable<any> {
		return api.eCommerce
			.getContentByUniqueID(productID)
			.withErrorHandling()
			.call();
	}
	public static getGroupContent(groupID: string): Observable<any> {
		return api.eCommerce
			.getGroupContent(groupID)
			.withErrorHandling()
			.call();
	}

	public static getContentBySearchTerm(searchTerm: string): Observable<any> {
		return api.eCommerce
			.getContentBySearchTerm(searchTerm)
			.withErrorHandling()
			.call();
	}

	public static getPackages(type: types.ecommerce.PackageType, group: types.ecommerce.PackageGroup): Observable<any> {
		return api.eCommerce
			.getPackages(group, type)
			.withErrorHandling()
			.call();
	}

	public static getContentByPartNumber(partNumber: string): Observable<any> {
		return api.eCommerce
			.getContentByPartNumber(partNumber)
			.withErrorHandling()
			.call();
	}
}
